import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import { App } from './containers/common/AgencyApp';
import store, { history } from './store';

import './main.scss';

const isLocalDev =
  process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.location.hostname === 'localhost';

if (isLocalDev && !(window as any).__axeInitialized) {
  (window as any).__axeInitialized = true;
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const axeCore = require('axe-core');
  const originalAxeRun = axeCore.run.bind(axeCore);
  let axeRunQueue: Promise<unknown> = Promise.resolve();

  // @axe-core/react can trigger overlapping runs on heavy pages; queue runs so only one executes at a time.
  axeCore.run = (...args: any[]) => {
    const callback = typeof args[args.length - 1] === 'function' ? args.pop() : undefined;

    const queuedRun = axeRunQueue.then(
      () =>
        new Promise((resolve, reject) => {
          const onComplete = (error: unknown, results: unknown) => {
            if (callback) {
              callback(error, results);
            }

            if (error) {
              reject(error);
            } else {
              resolve(results);
            }
          };

          try {
            originalAxeRun(...args, onComplete);
          } catch (error) {
            reject(error);
          }
        })
    );

    axeRunQueue = queuedRun.catch(() => undefined);

    if (!callback) {
      return queuedRun;
    }

    return undefined;
  };

  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const axe = require('@axe-core/react');
  // Large pages can take longer than a single aXe pass; keep scans far enough apart to reduce churn.
  axe(React, ReactDOM, 20000);
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('app')
);
